import {Realm} from "../environment/realm/realm";

export function $Uint8ClampedArrayPrototype$(realm: Realm) {
	return realm["[[GlobalObject]]"].Uint8ClampedArray.prototype;
}
